<template>
  <section 
    class="section--hero"
    :style="backgroundImageStyle"
  >
    <div class="section__container text-left">
      <div class="nav-indicator">
        <nav-indicator :nav-indicator="navIndicator" />
      </div>
      <v-row class="section__row" align="center" :justify="hasBackgroundImage ? 'center' : 'start'">
        <v-col cols="12" :md="imageName ? '7' : '12'" class="section__col">
          <div class="text__container" :class="{ 'text-centered': hasBackgroundImage }">
            
            <template v-if="reverseOrder">
              <h1 class="section__title" :class="{ 'text-center': hasBackgroundImage }" v-html="title" v-if="title"></h1>
              <p
                class="section__subtitle mt-4"
                :class="{ 'text-center': hasBackgroundImage }"
                v-if="subTitle"
                v-html="subTitle"
              ></p>
            </template>
            <template v-else>
              <p
                class="section__subtitle"
                :class="{ 'text-center': hasBackgroundImage }"
                v-if="subTitle"
                v-html="subTitle"
              ></p>
              <h1 class="section__title mt-4" :class="{ 'text-center': hasBackgroundImage }" v-html="title" v-if="title"></h1>
            </template>
            
            
            <p
              class="section__description m500 mt-3 mb-7"
              :class="{ 'text-center': hasBackgroundImage }"
              v-if="description"
              v-html="description"
            ></p>
            
          </div>
        </v-col>
        <v-col
          cols="12"
          md="5"
          class="section__col d-flex justify-center justify-md-end"
          v-if="imageName"
        >
          <keep-alive>
            <v-img
              class="section__image"
              :eager="true"
              :src="require(`@/assets/img/${imageName}`)"
              contain
            ></v-img>
          </keep-alive>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import NavIndicator from '@/components/partials/NavIndicator.vue';

export default {
  name: 'HeroSection',
  components: {
    NavIndicator,
  },
  props: {
    subTitle: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
    },
    showWhiteWave: {
      type: Boolean,
      required: false,
      default: false,
    },
    showBlueWaves: {
      type: Boolean,
      required: false,
      default: false,
    },
    showBlueWaves3: {
      type: Boolean,
      required: false,
      default: false,
    },
    showDarkerWave: {
      type: Boolean,
      required: false,
      default: false,
    },
    showPurpleWaves: {
      type: Boolean,
      required: false,
      default: false,
    },
    showLightBlueWaves: {
      type: Boolean,
      required: false,
      default: false,
    },
    imageName: {
      type: String,
      required: false,
    },
    hasButton: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonUrl: {
      type: String,
      required: false,
      default: '/',
    },
    buttonText: {
      type: String,
      required: false,
      default: 'default',
    },
    navIndicator: {
      type: Array,
      required: false,
      default: () => [],
    },
    reverseOrder: {
      type: Boolean,
      required: false,
      default: false,
    },
    backgroundImage: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    backgroundImageStyle() {
      if (this.backgroundImage) {
        return {
          backgroundImage: `url(${require(`@/assets/img/${this.backgroundImage}`)})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        };
      }
      return {};
    },
    hasBackgroundImage() {
      return !!this.backgroundImage;
    }
  }
};
</script>

<style scoped>
.section--hero {
  background-color: #f2f2f2;
  padding-top: 0rem;
  min-height: 400px;
  display: flex;
  /* flex-direction: column; */
  
}

/* Center content when background image is present */
.section--hero:has(.text-centered) .section__container {
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: center;
  text-align: center;
}

.text-centered {
  text-align: center !important;
  align-items: center !important;
  justify-content: center !important;
}

.text-centered .section__title,
.text-centered .section__subtitle,
.text-centered .section__description {
  text-align: center !important;
}
.nav-indicator {
  padding-left: 3%;
  
}
.section__container {
  margin-top: 0;
  padding-block: 2rem;
  width: 95%;
}

.section__subtitle {
  text-transform: capitalize;
  text-align: left;
  
}

.section__title {
  letter-spacing: 0%;
  line-height: 100%;
  text-align: left;
  font-size: clamp(16px, 2vw, 24px);
  margin-bottom: 20px;
}

.section__title .title__arrow {
  width: clamp(16px, 2vw, 20px);
  height: clamp(16px, 2vw, 20px);
}


.section__description {
  text-align: left;
}

.section__image {
  width: 100%;
  max-width: clamp(350px, 40vw, 550px);
  max-height: clamp(200px, 30vw, 300px);
  object-fit: contain;
}

.job-post__tags {
  margin-block: 1rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.job-post__skill-chip {
  margin-right: 0.5rem;
}

.job-post__details {
  margin-block: 1rem;
  display: flex;
  gap: 3rem;
  color: var(--gray-1);
}

.job-post__detail {
  display: flex;
  align-items: center;
}

.text__container {
  width: 100%;
  display: flex;
  flex-direction: column;
  text-align: left;
  justify-content: flex-start;
  align-items: flex-start;
}

@media only screen and (min-width: 960px) {
  .text__container {
    width: 100%;
    margin-left: 1.5rem;
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
@media only screen and (max-width: 960px) {
  .text__container {
    width: 90%;
    margin: auto;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .job-post__details {
    margin-block: 1rem;
    display: flex;
    gap: 1rem;
    color: var(--gray-1);
  }
}
@media only screen and (min-width: 1000px) {
  .text__container {
    width: 95%;
    margin-inline: auto;
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
@media only screen and (min-width: 1200px) {
  .text__container {
    width: 90%;
    margin-inline: auto;
    display: flex;
    flex-direction: column;
    text-align: left;
    justify-content: flex-start;
    align-items: flex-start;
  }
}

.hero__btn {
  background-color: #007ab2;
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  margin-bottom: 20px;
  margin-top: 10px;
  transition: background-color 0.3s ease-in-out, transform 0.2s ease-in-out;
}

.hero__btn:hover {
  background-color: #00aeff;
  transform: scale(1.05);
}
</style>